import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface MessageSelectionState {
  selectedMessages: Set<string>;
  modeSelected: boolean;

  dragSelecting: {
    startIndex: number;
    endIndex: number;
    mode: "select" | "deselect";
  } | null;
  isDragging: boolean;
  startDragPos: { x: number; y: number } | null;

  toggleMessage: (id: string) => void;
  selectMessages: (ids: string[]) => void;
  deselectMessages: (ids: string[]) => void;
  resetSelection: () => void;
  enterSelectionMode: () => void;
  exitSelectionMode: () => void;
  updateSelection: (ids: string[], mode: "add" | "remove") => void;

  setDragSelecting: (
    dragSelecting: MessageSelectionState["dragSelecting"]
  ) => void;
  setIsDragging: (isDragging: boolean) => void;
  setStartDragPos: (startDragPos: { x: number; y: number } | null) => void;
}

export const useMessageSelectionStore = create<MessageSelectionState>()(
  devtools((set, get) => ({
    selectedMessages: new Set(),
    modeSelected: false,

    dragSelecting: null,
    isDragging: false,
    startDragPos: null,

    enterSelectionMode: () => set({ modeSelected: true }),

    exitSelectionMode: () =>
      set({ modeSelected: false, selectedMessages: new Set() }),

    resetSelection: () =>
      set({ selectedMessages: new Set(), modeSelected: false }),

    toggleMessage: (id) => {
      set((state) => {
        // if (!state.modeSelected) return state;

        const newSet = new Set(state.selectedMessages);
        const wasSelected = newSet.has(id);
        if (wasSelected) {
          newSet.delete(id);
        } else {
          newSet.add(id);
        }

        const modeSelected = newSet.size > 0 ? true : false;

        return {
          selectedMessages: newSet,
          modeSelected,
        };
      });
    },

    updateSelection: (ids, mode) => {
      const { selectedMessages } = get();
      const newSet = new Set(selectedMessages);
      if (mode === "add") {
        ids.forEach((id) => newSet.add(id));
      } else {
        ids.forEach((id) => newSet.delete(id));
      }
      set({ selectedMessages: newSet });
    },

    selectMessages: (ids) => get().updateSelection(ids, "add"),
    deselectMessages: (ids) => get().updateSelection(ids, "remove"),

    setDragSelecting: (dragSelecting) => set({ dragSelecting }),
    setIsDragging: (isDragging) => set({ isDragging }),
    setStartDragPos: (startDragPos) => set({ startDragPos }),
  }))
);
